<template>
<main class="bg-main">
  <contenthead :section="sectionData" :lesson="lessonData" :contentsData="contentsData"></contenthead>

  <section class="container">

     <div class="heading-content-title">
      {{ $t('lesson.review.title') }}
    </div>

    <div class="buttons-at-the-bottom review">

      <div class="player-grammar">
        <vue-plyr ref="plyr" :options="playerOptions" :key="$route.fullPath">
          <video playsinline crossorigin :data-poster="movieData.movie.poster">
            <source>
            <track kind="captions" label="Japanese" srclang="ja" :src="movieData.movie.subtitles">
            <track kind="captions" label="English" srclang="en" :src="movieData.movie.en_subtitles">
            <track kind="captions" label="Nepali" srclang="np" :src="movieData.movie.np_subtitles">
            <track kind="captions" label="Vietnamese" srclang="vn" :src="movieData.movie.vn_subtitles">
            <track kind="captions" label="Thai" srclang="th" :src="movieData.movie.th_subtitles">
            <track kind="captions" label="Indonesian" srclang="id" :src="movieData.movie.id_subtitles">
            <track kind="captions" label="Spanish" srclang="es" :src="movieData.movie.es_subtitles">
            <track kind="captions" label="Portuguese" srclang="pt" :src="movieData.movie.pt_subtitles">
            <track kind="captions" label="Korean" srclang="kr" :src="movieData.movie.kr_subtitles">
            <track kind="captions" label="China" srclang="cn" :src="movieData.movie.cn_subtitles">
            <track kind="captions" label="Taiwan" srclang="tw" :src="movieData.movie.tw_subtitles">
          </video>
        </vue-plyr>
      </div>


      <div class="buttons-side-by-side">
        <a class="button button-primary button-back" @click="back">{{ $t('common.button.back') }}</a>
        <a class="button button-primary button-grammar next" @click="nextStep">{{ $t('common.button.next') }}</a>
      </div>

    </div>

  </section>

</main>
</template>

<script>
  import {api, appEnv} from './../../config';
  import learningLog from '../../mixins/learning-log';
  import status from '../../mixins/status';
  import {mapState} from 'vuex';
  import Hls from 'hls.js';

  import 'vue-plyr/dist/vue-plyr.css';

  import componentContentHead from '../shared/ContentHead.vue';

  export default {
    name: 'LessonReview',
    components: {
      'contenthead': componentContentHead,
    },
    mixins: [
      learningLog,
      status
    ],
    data () {
      return {
        step: 'review',
        lessonId: null,
        contents_data: {},
        playerOptions: {
          controls: [
            'play-large', // The large play button in the center
            // 'restart', // Restart playback
            // 'rewind', // Rewind by the seek time (default 10 seconds)
            'play', // Play/pause playback
            // 'fast-forward', // Fast forward by the seek time (default 10 seconds)
            'progress', // The progress bar and scrubber for playback and buffering
            'current-time', // The current time of playback
            'duration', // The full duration of the media
            'mute', // Toggle mute
            'volume', // Volume control
            'captions', // Toggle captions
            'settings', // Settings menu
            // 'pip', // Picture-in-picture (currently Safari only)
            // 'airplay', // Airplay (currently Safari only)
            // 'download', // Show a download button with a link to either the current source or a custom URL you specify in your options
            'fullscreen' // Toggle fullscreen
          ]
        },
        authUser: null,
        storage: {}

      }
    },
    computed: {
      ...mapState({
        user: state => state.auth
      }),
      sectionData() {
        return this.$store.getters.section_data;
      },
      lessonData() {
        return this.$store.getters.lesson_data;
      },
      contentsData() {
        return this.contents_data;
      },
      movieData() {
        let contentKeys = Object.keys(this.$store.getters.lesson_content.review.content)
        return (this.$store.getters.lesson_content.review.content && contentKeys[0] in this.$store.getters.lesson_content.review.content) ? this.$store.getters.lesson_content.review.content[contentKeys[0]] : { movie: {}}
      },
    },

    created() {
      let self = this;

      this.authUser = this.$store.getters.getAuthUser;

      if(!this.$store.getters.section_data || Object.keys(this.$store.getters.section_data).length == 0) {
          this.$router.push({ name: 'lesson.movie', params: { lesson_id: this.lessonId, content_order: 1 }})
      }

      this.lessonId = this.$route.params['lesson_id']


      axios.get(api.contents, {
        params: {
          lesson_id: this.$store.getters.lesson_data.lesson_id,
          lesson_type: this.$store.getters.lesson_data.lesson_type
        }
      })
      .then((resp) => {
        this.contents_data = resp.data
      })
    },

    mounted() {
      let self = this;

      const myVideo = document.getElementsByTagName('video')[0];
      myVideo.addEventListener('webkitbeginfullscreen webkitendfullscreen', event => {
        if(event.type === 'webkitbeginfullscreen') {
            document.documentElement.style.setProperty('--webkit-text-track-display', 'block');
        } else {
            document.documentElement.style.setProperty('--webkit-text-track-display', 'none');
        }
      });

      // Set video path
      if (Hls.isSupported() && appEnv === 'production') {
        const hls = new Hls();
        hls.loadSource(this.movieData.movie.movie);
        hls.attachMedia(myVideo);
      } else {
        const source = document.getElementsByTagName('source')[0];
        source.setAttribute("src", this.movieData.movie.movie);
      }
      myVideo.load();


      const player = this.$refs.plyr.player
    },
    methods: {
      nextStep() {
        if (this.$store.getters.lesson_content[this.step].status != 'completed' || this.movieData.status_review != 'completed') {
          this.statusContent('completed', this.step, { content_data_type: 'review', content_data_order: '1'});
        }
        this.learningTempLog();
        this.learningLog();

        this.$router.push({name: 'lesson.explanation', params: { lesson_id: this.lessonId, step: 'exam' }});
      },
      back() {
        let movieContentKeys = Object.keys(this.$store.getters.lesson_content.moviequiz.content)
        this.$router.push({name: 'lesson.quiz', params: { lesson_id: this.lessonId, content_order: movieContentKeys[movieContentKeys.length - 1] }});
      },
    },
  }
</script>
